import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useAppDispatch } from "../../../hooks/hooks";
import { useSearchWarrantReducer, updateElementObjectValue } from "../../../redux/slice/searchWarrantSlice";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

interface CustodianFormCheckboxProps {
  formType: string;
  className?: string;
}

const CustodianFormCheckbox: React.FC<CustodianFormCheckboxProps>= (props) => {
  const { className, formType } = props;
  const dispatch = useAppDispatch();
  const { searchWarrantObject } = useSearchWarrantReducer();
  const [includeCustodianForm, setIncludeCustodianForm] = useState<boolean>(
    !!searchWarrantObject.includeCustodianOfRecordsForm
  );
  const custodianFormUrl = 'templateservices/business-record-affidavit';
  const COMPL_SEARCH_WARRANT_WITH_SLASH = "Complaint/Search Warrant";
  const { token } = useSelector((state: RootState) => state.login);

  // Update local state when Redux state changes
  useEffect(() => {
    setIncludeCustodianForm(!!searchWarrantObject.includeCustodianOfRecordsForm);
  }, [searchWarrantObject.includeCustodianOfRecordsForm]);

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    setIncludeCustodianForm(isChecked);
    dispatch(
      updateElementObjectValue({
        elementName: "includeCustodianOfRecordsForm",
        value: isChecked,
      })
    );
  };

  // Construct authenticated URL with JWT token
  const getAuthenticatedCustodianFormUrl = () => {
    const baseUrl = process.env.REACT_APP_REST_URL + custodianFormUrl;
    return token ? `${baseUrl}?jwtToken=Bearer ${token}` : baseUrl;
  };

  if (formType !== COMPL_SEARCH_WARRANT_WITH_SLASH) {
    return null;
  }

  return (
    <div className={className}>
          <Row className="d-block fw-bold text-center text-danger">
            <hr />
          </Row>

          <Row>
            <Col className="d-flex align-items-center text-left mt-2 mb-2">

              <input
                type="checkbox"
                id="includeCustodianForm"
                checked={includeCustodianForm}
                className="mb-1"
                onChange={handleCheckboxChange}
              />

              <label
                htmlFor="includeCustodianForm"
                className="ms-2 mb-1 fw-bold"
                style={{ whiteSpace: "nowrap" }}
              >
                ATTACH BUSINESS RECORDS CERTIFICATION AFFIDAVIT
              </label>

              <a
                href={getAuthenticatedCustodianFormUrl()}
                target="_blank"
                rel="noopener noreferrer"
                className="ms-3 text-primary mb-1"
                style={{ whiteSpace: "nowrap" }}
              >
                Business Records Certification Affidavit
              </a>
            </Col>
          </Row>

      <Row className="d-block fw-bold text-center text-danger mt-1">
        <hr />
      </Row>
    </div>
  );
};

export default CustodianFormCheckbox;
